/**
 * Generated by orval v7.10.0 🍺
 * Do not edit manually.
 * ASP.NET 8 Web API for RIGHTIO Booking System - DEVELOPMENT
 * This is the API for the RIGHTIO Booking System, it is used to provide the booking system with data and to update the booking system with data.
 * OpenAPI spec version: v1
 */
import type {
  RightioGoCardlessAPIWrapperModelsDtoBankAccountDto,
  RightioGoCardlessAPIWrapperModelsDtoBankAccountRequestDto,
  RightioGoCardlessAPIWrapperModelsDtoCustomerDto,
  RightioGoCardlessAPIWrapperModelsDtoCustomerRequestDto
} from '../../model';

import { customInstance } from '../../../../../services/DatabaseAccess/index';
import type { BodyType } from '../../../../../services/DatabaseAccess/index';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];


  /**
 * Creates a new customer record in GoCardless system with personal details and address information. Required before setting up direct debit mandates or bank accounts.
 * @summary Creates a new customer
 */
export const postCustomer = (
    rightioGoCardlessAPIWrapperModelsDtoCustomerRequestDto: BodyType<RightioGoCardlessAPIWrapperModelsDtoCustomerRequestDto>,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioGoCardlessAPIWrapperModelsDtoCustomerDto>(
      {url: `/api/GoCardless/GoCardless/Customers`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: rightioGoCardlessAPIWrapperModelsDtoCustomerRequestDto
    },
      options);
    }
  /**
 * Creates a new bank account record in GoCardless for direct debit setup. Requires existing customer and validates UK bank account details (account number, sort code).
 * @summary Creates a new Bank Account
 */
export const postBankAccount = (
    rightioGoCardlessAPIWrapperModelsDtoBankAccountRequestDto: BodyType<RightioGoCardlessAPIWrapperModelsDtoBankAccountRequestDto>,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<RightioGoCardlessAPIWrapperModelsDtoBankAccountDto>(
      {url: `/api/GoCardless/GoCardless/BankAccounts`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: rightioGoCardlessAPIWrapperModelsDtoBankAccountRequestDto
    },
      options);
    }
  export type PostCustomerResult = NonNullable<Awaited<ReturnType<typeof postCustomer>>>
export type PostBankAccountResult = NonNullable<Awaited<ReturnType<typeof postBankAccount>>>
